var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"panelContainer",staticClass:"panel-container"},[(_vm.imageUrl)?_c('img',{ref:"displayImage",style:({
				width: _vm.canvasWidth+'px',
				height: _vm.canvasHeight+'px'
			}),attrs:{"src":_vm.imageUrl},on:{"click":function($event){return _vm.$emit('click')}}}):_vm._e(),(_vm.layers)?[_c('canvas',{ref:"displayCanvas",class:{'no-image' : !_vm.imageUrl},style:({
				width: _vm.canvasWidth+'px',
				height: _vm.canvasHeight+'px',
				display: 'inline-block',
				position: _vm.imageUrl ? 'absolute' : 'relative'
			}),attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight},on:{"click":function($event){return _vm.$emit('click')}}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }